<!-- REF: 41.2 -->
<template>
  <gv-modal
    data-theme="mobile"
    :modal="modal"
    size="custom"
    :custom-size-class="tw`w-[314px] p-6`"
    layout="flex-col"
    :close-on-click-outside="false"
    :border-radius="tw`rounded-2xl`"
    :aria-labelledby="headingId"
  >
    <template #header>
      <div></div>
    </template>

    <div v-if="!isComplete" class="flex flex-col gap-6">
      <mep-type is="h2" :id="headingId" variant="feature-large">
        Are you sure you want to exit? Any progress you’ve made will not be saved.
      </mep-type>
      <div class="flex flex-row gap-2">
        <mep-button text="Return to plan" variant="text" class="flex flex-1 py-2" @click="modal.setClosed" />
        <mep-button text="Exit without saving" variant="primary" class="flex px-4 py-2" @click="onExitWithoutSaving" />
      </div>
    </div>
    <div v-else class="flex flex-col gap-6">
      <div class="flex flex-col gap-2">
        <mep-type is="h2" :id="headingId" variant="feature-large"> Have you saved your plan? </mep-type>
        <mep-type variant="body-large">
          You won’t be able to access it again after you exit. Make sure you download or share it to keep a copy.
        </mep-type>
      </div>
      <div class="flex flex-row gap-2">
        <mep-button text="Return to plan" variant="text" class="flex flex-1 px-4 py-2" @click="modal.setClosed" />
        <mep-button text="Exit" variant="primary" class="flex flex-1 px-4 py-2" @click="onExitWithoutSaving" />
      </div>
    </div>
  </gv-modal>
</template>

<script lang="ts" setup>
import { tw } from '@/common';

import { inject, useId, computed, watch } from 'vue';
import * as Symbols from '@/common/constants/symbols';
import { useMyEmergencyPlanStore } from '@/features/my-emergency-plan/presentation/bloc/my-emergency-plan-bloc';
import { storeToRefs } from 'pinia';
import { MyEmergencyPlanStatus } from '../utils/types';

const headingId = useId();

const myEmergencyPlanStore = useMyEmergencyPlanStore();
const { planStatus } = storeToRefs(myEmergencyPlanStore);

const isComplete = computed(
  () => planStatus.value == MyEmergencyPlanStatus.Completed || planStatus.value == MyEmergencyPlanStatus.ViewingPlan
);

const { modal, planModal } = {
  modal: inject(Symbols.MyEmergencyPlanExitModal)!,
  planModal: inject(Symbols.MyEmergencyPlanModal)!,
};

const onExitWithoutSaving = async () => {
  await myEmergencyPlanStore.exitWithoutSaving();
  modal.setClosed();
  planModal.setClosed();
};

watch(
  () => modal.open.value,
  (open) => {
    if (open && planStatus.value == MyEmergencyPlanStatus.NotStarted) {
      onExitWithoutSaving();
    }
  }
);
</script>
